import { render, staticRenderFns } from "./TableCellProductVariations.vue?vue&type=template&id=40b20169&scoped=true"
import script from "./TableCellProductVariations.vue?vue&type=script&lang=js"
export * from "./TableCellProductVariations.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40b20169",
  null
  
)

export default component.exports